import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { PaginationState } from '@shared/models/pagination-state';
import { GroupFilters } from '@shared/models/group-filters';
import { Sorting } from '@shared/models/sorting';
import { Observable } from 'rxjs';
import { Group } from '@shared/models/group';

@Injectable({
  providedIn: 'root',
})
export class GroupsApiService {
  constructor(private apiService: ApiService) {}

  show(group_id: string): Observable<{ data: Group }> {
    return this.apiService.get(`v1/groups/${group_id}`, {});
  }

  index(
    paginationState: PaginationState,
    filters: GroupFilters,
    sorting: Sorting,
  ): Observable<{ data: Group[]; meta: PaginationState }> {
    let params = {
      ...filters,
      page: paginationState.page,
      per_page: paginationState.per_page,
      sort: `${sorting.key}`,
      sort_direction: `${sorting.direction}`,
    };
    return this.apiService.get('v1/groups', params);
  }

  create(group: Partial<Group>): Observable<{ data: Group }> {
    return this.apiService.post(`v1/groups`, { data: group });
  }

  update(group: Partial<Group>): Observable<{ data: Group }> {
    return this.apiService.put(`v1/groups/${group.id}`, { data: group });
  }

  batch_update(group: Partial<Group>, filters: GroupFilters): Observable<{}> {
    return this.apiService.patch(`v1/groups/batch_update`, { data: group, ...filters });
  }

  resendEmailConfirmation(group_id: string, email: string): Observable<{}> {
    return this.apiService.put(`v1/groups/${group_id}/send_email_confirmation`, {
      data: { email: email },
    });
  }

  generateApiSettingTokenAndSecret(group_id: string): Observable<{ data: { token: string; secret: string } }> {
    return this.apiService.put(`v1/groups/${group_id}/generate_api_setting_token_and_secret`, {});
  }

  sendAgreementForSignatures(group_id: string, email: string): Observable<any> {
    return this.apiService.post(`v1/groups/${group_id}/send_agreement_for_signatures`, { data: { email: email } });
  }

  updateExternalSubscriptions(group_id: string): Observable<any> {
    return this.apiService.put(`v1/groups/${group_id}/update_external_subscriptions`, {});
  }
}
